<div class="destination-bg">
</div>
<div id="outer_container">
    <div class="container-fluid noPadding">
    <!-- uiView: content -->
        <div
            id="content"
            ui-view="content"
            class="angular-animate ng-scope"
            autoscroll="true"
            mtc-scroll-to-invalid=""
        >
            <!-- video controls -->
            <!-- <div class="video-control">
                <button id="myBtn" class="btn2 btn2-light" onclick="myFunction()"></button>
            </div> -->
            <!-- video controls -->
            <div class="ng-scope">
            <div class="container">
                <div class="home">
                    <div class="type-container ng-scope">
                        <div class="type-headline">
                            <h1>Destination and Hotel Information</h1>
                        </div>
                        <div class="type-copy row d-flex g-0">
                            <div class="col-12 col-lg-6">
                                <p>
                                    <strong>Monte Carlo, Monaco</strong><br>
                                    Immerse yourself in the glamour and mystique of <a href="https://www.visitmonaco.com/en/explore/the-neighbourhoods-of-monaco/monte-carlo" target="_blank">
                                    Monte Carlo, Monaco</a>, the crown jewel of the French Riviera. 
                                    This storybook principality offers an unparalleled Mediterranean experience. From its perch high on the cliffs of 
                                    Mont des Mules, this tiny nation — less than two miles wide — attracts elite travelers from around the globe to 
                                    come and play on its lavish stretch of Riviera coastline. Explore the legendary Monte Carlo Casino, where Belle 
                                    Époque architecture meets the exhilarating rush of world-class gaming. Spend your days strolling the chic promenades, 
                                    discovering haute couture in exclusive boutiques or exploring the charming streets of nearby centuries-old villages. 
                                    Evenings offer a diverse, lively social scene, from opera and ballet to symphony performances and exquisite dining 
                                    experiences, all with captivating views that make Monte Carlo a legendary destination of timeless alure and high-stakes indulgence.
                                </p>
                            </div>
                            <div class="col-12 col-lg-6">
                                <img class="destination-img" src="assets/images/monte-carlo.jpg">
                            </div>
                            
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>Currency:</strong> The currency of Monaco is the euro (EUR). Current conversion rates can be found at 
                                <a href="http://www.xe.com/ucc/" target="_blank">XE</a>. 
                            </p>
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>Electric Current:</strong> In Monaco, the standard voltage is 230 V, and they use “Type C and E” electrical plugs. 
                                For information on the voltages of these plugs and to view images of each plug/outlet type, 
                                visit <a href="https://www.worldstandards.eu/electricity/plugs-and-sockets/" target="_blank">WorldStandards.eu</a>. 
                                For your convenience, the hotel provides a hair dryer in each guest room and USB charging outlets.
                            </p>
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>Sun Warning:</strong> The sun’s intensity can be quite strong. To avoid burns, 
                                it is advisable to limit your sun exposure and use plenty of sunscreen. 
                            </p>
                        </div>
                        
                        <div class="type-copy">
                            <p>
                                <strong>Time:</strong> Monaco will observe Central European Time during your stay. Therefore, the time difference will be as follows:
                            </p>
                            <div class="table-responsive mb-3">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Los Angeles</th>
                                            <th>Chicago</th>
                                            <th><strong>Monte Carlo</strong></th>
                                            <th>Germany</th>
                                            <th>India</th>
                                            <th>Beijing</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>7:00 AM</td>
                                            <td>9:00 AM</td>
                                            <td><strong>3:00 PM</strong></td>
                                            <td>3:00 PM</td>
                                            <td>7:30 PM</td>
                                            <td>10:00 PM</td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                             
                        </div>
                        
                        <div class="type-copy">
                            <p>
                                <strong>Weather:</strong> Average temperatures in Monte Carlo during the dates of your trip range 
                                from daytime highs of 59 F/15 C, to evening lows of 45 F/7 C. Unseasonable weather can occur at any 
                                time; for up-to-date information, please check visit 
                                <a href="https://www.accuweather.com/en/mc/monte-carlo-spelugues/1097282/march-weather/1097282?year=2027" target="_blank">accuweather.com</a>
                                 prior to your departure.
                            </p>
                        </div>
                        
                        <div class="type-copy row d-flex g-0">
                            <p>
                                <strong>Fairmont Monte Carlo:</strong><br>
                                Chic and refined, the iconic <a href="https://www.fairmont.com/en/hotels/monte-carlo/fairmont-monte-carlo.html?" target="_blank">Fairmont Monte Carlo</a> 
                                is the Riviera at its peak of splendor. 
                                Set where the Mediterranean meets "The Rock," this landmark hotel offers unparalleled views of the sea, 
                                Port Hercule's impressive yachts and even the legendary Circuit de Monaco Hairpin. A signature highlight of the hotel, 
                                this legendary spot just outside its doors is the slowest bend in the Grand Prix course, requiring exceptional skill as 
                                Formula One drivers navigate the tight turn. Inside, the Fairmont's luxurious amenities and impeccable service ensure 
                                an unforgettable stay. Savor world-class cuisine at the rooftop restaurant, Nobu's acclaimed Japanese-Peruvian fusion 
                                restaurant or the vibrant poolside bar. Indulge in sumptuous spa treatments or elevate your workout at the well-equipped 
                                fitness center. Then, after your supremely satisfying days spent discovering Monte Carlo, your elegant guest room 
                                awaits with breezy, maritime-inspired décor that provides a tranquil, soothing retreat.
                            </p>

                            <div class="col-12 col-lg-6">
                                <img class="destination-img" src="assets/images/fairmont.jpg">
                            </div>
                            <div class="col-12 col-lg-6">
                                <p><strong>Guest room amenities:</strong></p>
                                <ul>
                                    <li>Private furnished terrace
                                    <li>High-Speed Wi-Fi</li>
                                    <li>Flat-screen television</li>
                                    <li>Comfortable sitting area</li>
                                    <li>In-room safe</li>
                                    <li>Iron and ironing board</li>
                                    <li>Marble bath with deluxe toiletries</li>
                                    <li>Hair dryer</li>
                                </ul>
                            </div>
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>Contact Information</strong><br>
                                Fairmont Monte Carlo<br>
                                12 Avenue des Spélugues<br>
                                98000 Monte Carlo, Monaco<br>
                                Telephone: 377-93-50-65-00
                            </p>
                            <p>Check-in time is 4:00 PM, and checkout time is 10:00 AM.</p>
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>Resort Extensions</strong><br>
                                The special group room rate at Fairmont Monte Carlo starts at ${{ extensionRate() }} (plus taxes) per room, per night based on double occupancy.
                                The rate is available three days before and three days after the program dates. Extension rooms at the hotel are limited in availability
                                and not guaranteed until the time of booking. Once we have received your completed registration, a travel associate will contact you to verify your request.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
